import './ruhe152/style';
import FormStructure from './ruhe152/form_structure';

export default FormStructure;